import { MessageCircle } from 'lucide-react'
import { useMaiaStore } from '../../core/stores/maiaStore'

export default function MaiaChatButton() {
  const { toggle, isOpen, wakeWordActive } = useMaiaStore()

  if (isOpen) return null

  return (
    <button
      onClick={toggle}
      className={`
        fixed bottom-4 right-4 z-50 w-14 h-14 rounded-full
        flex items-center justify-center
        transition-all duration-200 hover:scale-110
        text-white
      `}
      style={{
        backgroundColor: '#6366f1',
        boxShadow: '0 4px 15px rgba(99, 102, 241, 0.5), 0 2px 8px rgba(0, 0, 0, 0.3)',
      }}
      title={wakeWordActive ? 'ELETTRA in ascolto... (Ctrl+M)' : 'ELETTRA Assistant (Ctrl+M)'}
    >
      <MessageCircle className="w-6 h-6" />
      {/* Indicatore wake word attivo */}
      {wakeWordActive && (
        <span
          className="absolute top-0 right-0 w-3.5 h-3.5 rounded-full border-2 animate-pulse"
          style={{
            backgroundColor: '#22c55e',
            borderColor: '#6366f1',
          }}
        />
      )}
    </button>
  )
}
